/* global $ */
import Mojito from '../../../bower_components/mojito/lib/main';

export default class NavigationController extends Mojito.Controller {

    constructor(...args) {
        super(args);

        this.set('navFixed', false);
        this.set('mobileNavOpen', false);
        this.set('offsetTop', this.$().offset().top);

        this.checkScrolling();
    }

    toggle() {
        let button = this.$().find('.navicon-button');

        if (!this.get('mobileNavOpen')) {
            this.set('mobileNavOpen', true);
            this.$().addClass('moblieNav--open');
            button.addClass('open');
        } else {
            this.set('mobileNavOpen', false);
            this.$().removeClass('moblieNav--open');
            button.removeClass('open');
        }
    }

    navFixedObserver() {
        return Mojito.observer('navFixed', function () {
            if (this.get('navFixed')) {
                $('body').addClass('navFixed');
                this.$().addClass('is--fixed');
            } else {
                $('body').removeClass('navFixed');
                this.$().removeClass('is--fixed');
            }
        });
    }

    checkScrolling() {
        // if(!Modernizr.touch) {
        $(window).on('scroll', (event) => {
            event.preventDefault();
            if ($(window).scrollTop() > this.get('offsetTop')) {
                if (!this.get('navFixed')) {
                    this.set('navFixed', true);
                }
            } else {
                if (this.get('navFixed')) {
                    this.set('navFixed', false);
                }
            }
        });
        // }
    }
}
